import { call, put, takeLatest } from "redux-saga/effects";
import { httpDeleteQuestion } from "../../../services/questions";
import {
  deleteQuestionStart,
  deleteQuestionSuccess,
  deleteQuestionFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { successNotifier } from "../../../utils/helpers";

function* deleteQuestion({ payload }) {
  const { id, callback } = payload;
  const response = yield call(httpDeleteQuestion, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteQuestionSuccess(raw));
    successNotifier("Question deleted successfully");

    if (callback) {
      callback();
    }
  } else {
    yield put(deleteQuestionFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onDeleteQuestion() {
  yield takeLatest(deleteQuestionStart.type, deleteQuestion);
}
